export default {
  banner: {
    euAddTaxId: 'Have a {{children}}? Please add it to the Tax Policies section of your account.',
    buttonText: 'Submit my tax info',
    VAT: 'VAT ID',
    GST: 'GST ID',
    learnMore: 'Learn more',
    caTaxTitle: 'Reverb began assessing tax on fees for sellers in Canada on 12 August 2024.',
    caTaxContent: 'You can learn more about this tax policy in our Help Center.',
  },
};
